import React ,{useEffect} from 'react';
import TableContainer from '@mui/material/TableContainer';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Link from '@mui/material/Link';
import Toolbar from '@mui/material/Toolbar';
import { DateCellStyling,ContentCellStyling,CellTypographyStyling} from './BiogTableStyles';
import useSharedDocHeader from "./DocHeaderHook";
import { useTranslation } from 'react-i18next';
import MailChimpSubscribe from './MailChimpSubscribe';
import Grid2 from '@mui/material/Unstable_Grid2/Grid2';

export default function Contact() {
  const { t } = useTranslation('common');
  const {doSetTitleKey,doSetMetaDescKey,doSetRouterId} = useSharedDocHeader();

  useEffect(() => {
    doSetTitleKey("common:LABEL_CONTACT");
    doSetMetaDescKey("common:LABEL_DESC_CONTACT");
    doSetRouterId("/Contact");
  }, []);

  return (
    <Grid2 height="100vh" container flex={1} direction={'column'} sx={{alignItems:'center',pt:7, width: '100%',  bgcolor: 'background.paper' }}>
      <Box sx={{pt:4}}>
      <TableContainer >
        <Table size="small" aria-label="a dense table">
          <TableBody>
            <TableRow key="addr" sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
              <TableCell component="td" padding="normal" sx={DateCellStyling}>
                {t('common:LABEL_ADDRESS') + ':'} 
              </TableCell>
              <TableCell align="left" padding="none" sx={ContentCellStyling}>
                <Typography sx={CellTypographyStyling}>Marschalkenstrasse 24</Typography>
                <Typography sx={CellTypographyStyling}>CH-4054 Basel</Typography>
              </TableCell>
            </TableRow>
            <TableRow key="email" sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
              <TableCell component="td" padding="normal" sx={DateCellStyling}>
                {t('common:LABEL_EMAIL') + ':'} 
              </TableCell>
              <TableCell align="left" padding="none" sx={ContentCellStyling}>
                <img src='http://www.noravest.ch/img/aaa.gif'/>
              </TableCell>
            </TableRow>
            <TableRow key="telephone" sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
              <TableCell component="td" padding="normal" sx={DateCellStyling}>
                {t('common:LABEL_TELEPHONE') + ':'} 
              </TableCell>
              <TableCell align="left" padding="none" sx={ContentCellStyling}>
                <Typography sx={CellTypographyStyling}>061 281 4019</Typography>
              </TableCell>
            </TableRow>
            <TableRow key="studioAddr" sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
              <TableCell component="td" padding="normal" sx={DateCellStyling}>
                {t('common:LABEL_ADDRESS_STUDIO') + ':'} 
              </TableCell>
              <TableCell align="left" padding="none" sx={ContentCellStyling}>
                <Typography sx={CellTypographyStyling}>Auf dem Wolf 5</Typography>
                <Typography sx={CellTypographyStyling}>CH-4052 Basel</Typography>
                <Link color="inherit" target="_blank" href="https://www.google.com/maps/place/Auf+dem+Wolf+5,+4052+Basel/@47.5401398,7.6112423,17z/data=!3m1!4b1!4m5!3m4!1s0x4791b825706fdc41:0x6e1d6b540cd8c9dc!8m2!3d47.5401362!4d7.613431">GoogleMaps</Link>
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
      </Box>
      <Toolbar/>
      <MailChimpSubscribe/>
    </Grid2>
    
  )
}
